<div class="form-group">
	<antenne-selector
		[id]="'choixAntenne'"
		[disabled]="antenneDisabled"
		[mandatory]="true"
		[labelClass]="labelClass"
		[fieldClass]="contextFieldClass"
		[wildcardOptionLabel]="' '"
		[resetCommands]="resetAntenneIdCommands"
		(selectedAntenneIdChange)="onAntenneIdChange($event)"
		>
	</antenne-selector>
	<parc-selector
		[id]="'choixParc'"
		[disabled]="fieldsDisabled"
		[mandatory]="true"
		[labelClass]="labelClass"
		[fieldClass]="contextFieldClass"
		[antenneId]="antenneId ? antenneId : null"
		[(selectedParcId)]="_parcId"
		(selectedParcIdChange)="parcIdChange.emit($event)"
		(selectedParcChange)="onParcChange($event)"
		(parcSelected)="onParcSelected($event)"
		>
	</parc-selector>
</div>

<div class="form-group" *ngIf="_parcId">
	<ouvrage-by-sous-parc-multi-selector
		*ngIf="parcId"
		[id]="'choixOuvrage'"
		[disabled]="fieldsDisabled"
		[labelClass]="labelClass"
		[fieldClass]="ouvrageFieldClass"
		[parc]="selectedParc"
		[(selectedOuvrageIds)]="ouvrageIds"
		(selectedOuvrageIdsChange)="ouvrageIdsChange.emit($event)"
		>
	</ouvrage-by-sous-parc-multi-selector>
</div>